import { useState } from 'react'
import Box from '@mui/material/Box'
import { StyledTooltip } from 'components/core/Tooltip'
import {
  toClipLocalDateTimeString,
  toViewerDateTimeString,
} from 'services/utils'

const ReclipCreatedTimestamp = ({ createdAt, clippedAt }) => {
  const [showClipLocal, setShowClipLocal] = useState(false)
  const createdTime = toViewerDateTimeString(createdAt)
  const clipLocalTime = toClipLocalDateTimeString(clippedAt?.date_local_tz)
  const canToggle = Boolean(clipLocalTime)
  const isShowingClipLocal = canToggle && showClipLocal
  const label = isShowingClipLocal ? 'Captured locally' : 'Created'
  const value = isShowingClipLocal ? clipLocalTime : createdTime

  if (!createdTime) return null

  if (!canToggle) {
    return (
      <Box>
        <b>Created: </b>
        {createdTime}
      </Box>
    )
  }

  return (
    <Box>
      <b>{label}: </b>
      <StyledTooltip
        title={
          isShowingClipLocal
            ? 'Click to show created time'
            : 'Click to show clip-local time'
        }
      >
        <Box
          component="button"
          type="button"
          onClick={() => setShowClipLocal((prev) => !prev)}
          sx={{
            all: 'unset',
            cursor: 'pointer',
            display: 'inline',
            font: 'inherit',
          }}
        >
          {value}
        </Box>
      </StyledTooltip>
    </Box>
  )
}

export default ReclipCreatedTimestamp
